/**
 * Created by admin on 2017/3/23.
 */
import uploader from '../../lib/plupload-2.1.2/js/plupload.dev.js'
import NProgress from 'nprogress'
import {
    GetParmConfig,
    GetProductClass,
    ParmConfigAdd,
    ParmConfigDel,
    GetProductAttribute
} from '@api/commonApi.js';
import {
    ProductAdd,
    GetProductById,
    ProductUpdate
} from '@api/productApi.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';
import routes from '../../routes';

module.exports = {
    mounted: function () {
        this.getClass();
        this.getSelectList(1); //种类 
        this.getSelectList(2); //类型
        this.getSelectList(3); //品牌
        this.getSelectList(4); //规格
        this.getSelectList(5); //型号
        this.getSelectList(6); //自然单位
        this.getSelectList(7); //销售单位
        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            this.$store.dispatch("getRouterName", "修改单品")
            this.Update = true;
            let para = {
                Sid: this.$route.query.Sid,
                Session: this.$route.query.Session,
                Id: this.$route.query.Id
            };
            GetProductById(para).then(res => {
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.Form = [];
                    this.Form = Data;
                    this.activenaturalUnits = this.Form.ProNaturalUnit;
                    this.activesaleUnits = this.Form.ProSaleUnit;
                    this.PictureList = this.Form.ProImgUrl;
                    if (this.$route.query.view == "true") {
                        this.$store.dispatch("getRouterName", "查看单品")
                        this.isEdit = false;
                        this.Upload = false;
                    }
                });

            });
        } else {
            this.$store.dispatch("getRouterName", "添加单品")
        }
        util.uploadPicture(this, this.flag);
    },
    data() {
        return {
            fullPicture: false,
            PictureList: [],
            flag: "1",
            logining: false,
            Upload: true,
            isEdit: true,
            Update: false,
            Session: util.getSessin(),
            Category: [], //种类
            ProTypeName: [], //类型/科目类型
            Brand: [], //品牌
            ProSpecName: [], //规格/类别
            ProModelNumName: [], //型号、册数ss
            naturalUnits: [], //自然单位
            saleUnits: [], //销售单位
            Class: [], //产品分类
            Attribute: [], //产品属性
            StockTypeNames: MAP_LIST.STOCKTYPE_NAME, //仓库类型
            activenaturalUnits: "",
            activesaleUnits: "",
            Form: this.submitFormData(),
            visibleShow: false,
            table: {},
            dialogContent: "",
            PictureVisible: false,
            dialogImageUrl: "",
        }
    },
    watch: {
        activenaturalUnits: function () {
            if (this.activenaturalUnits !== 0) {
                this.Form.ProNaturalUnit = this.naturalUnits.find(item => item.Id == this.activenaturalUnits).ParmName;
            }
        },
        activesaleUnits: function () {
            if (this.activesaleUnits !== 0) {
                this.Form.ProSaleUnit = this.saleUnits.find(item => item.Id == this.activesaleUnits).ParmName
            }
        },
        PictureList: function () {
            if (this.Upload) {
                if (this.PictureList.length == 9) {
                    this.fullPicture = true;
                    this.$notify({
                        title: '提示',
                        message: "最多只能上传9张图片，当前已达上限",
                        type: 'info'
                    });
                } else {
                    this.fullPicture = false;
                }
            }
        },
    },
    methods: {
        submitFormData() {
            return cloneDeep({
                ProName: "",
                ProNick: "",
                ProCode: "",
                ProClass: "",
                ProAttribute: "",
                ProCategory: "",
                ProTypeId: "",
                ProBrand: "",
                ProSpec: "",
                ProModelNum: "",
                ProProportion1: "",
                ProProportion2: "",
                ProImgUrl: [],
                ProNaturalUnit: "",
                ProSaleUnit: "",
                ProRemark: "",
                Price: "",
                SalePrice: "",
                StockType: "",
            });
        },
        LookPicture(Url) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: Url,
                    id: ""
                }]
            });
        },
        delPicture(Url) {
            if (this.PictureList.length > 0) {
                for (var i = 0; i < this.PictureList.length; i++) {
                    if (this.PictureList[i].Url == Url) {
                        this.PictureList.splice(i, 1);
                    }
                }
            }
        },
        submit() {
            if (this.isEdit) {

                let params = cloneDeep(this.Form)
                params.ProNaturalUnit = this.activenaturalUnits
                params.ProSaleUnit = this.activesaleUnits
                var a = [];
                for (var i = 0; i < this.PictureList.length; i++) {
                    var b = {};
                    b.Name = this.PictureList[i].Name;
                    b.Url = this.PictureList[i].Url;
                    a.push(b);
                }
                params.ProImgUrl = a;

                if (this.Update == false) {
                    ProductAdd(params).then(res => {
                        util.doResult(this, res, () => {
                            this.$notify({
                                title: '成功',
                                message: '添加成功',
                                type: 'success'
                            });
                            this.$router.push('/productInformation/productControl');
                        });

                    })
                } else {
                    params.ProductId = this.$route.query.Id;
                    ProductUpdate(params).then(res => {
                        util.doResult(this, res, () => {
                            this.$notify({
                                title: '成功',
                                message: '更新成功',
                                type: 'success'
                            });
                            this.$router.push({
                                path: '/productInformation/productControl',
                                query: {
                                    'reload': true
                                }
                            });
                        });
                    });
                }
            } else {
                this.$router.push({
                    path: '/productInformation/productControl',
                    query: {
                        'reload': true
                    }
                });
            }

        },
        mydialog(type) {
            this.visibleShow = true;
            if (type == 1) {
                this.table = {
                    title: "分类",
                    data: this.Category,
                    label: "分类",
                    type: 1
                };
            };
            if (type == 2) {
                this.table = {
                    title: "类型或科目管理",
                    data: this.ProTypeName,
                    label: "类型或科目",
                    type: 2
                };
            };
            if (type == 3) {
                this.table = {
                    title: "品牌管理",
                    data: this.Brand,
                    label: "品牌",
                    type: 3
                };
            };
            if (type == 4) {
                this.table = {
                    title: "规格和类别管理",
                    data: this.ProSpecName,
                    label: "规格和类别",
                    type: 4
                };
            };
            if (type == 5) {
                this.table = {
                    title: "型号/册数管理",
                    data: this.ProModelNumName,
                    label: "型号和册数",
                    type: 5
                };
            };
            if (type == 6) {
                this.table = {
                    title: "自然单位管理",
                    data: this.naturalUnits,
                    label: "自然单位",
                    type: 6
                };
            };
            if (type == 7) {
                this.table = {
                    title: "销售单位管理",
                    data: this.saleUnits,
                    label: "销售单位",
                    type: 7
                };
            };
        },
        delTable(index, item, type) {
            let para = {
                Ids: item.Id
            };
            ParmConfigDel(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.getSelectList(type);
                    this.activeSelect(type, item.Id)
                }
            })
        },
        addDialog(type) {
            var para = {
                ParmType: type,
                ParmName: this.dialogContent
            };
            ParmConfigAdd(para).then(res => {
                util.doResult(this, res, () => {
                    this.dialogContent = "";
                    this.visibleShow = false;
                    this.getSelectList(type, 1);
                });
            })
        },
        activeSelect(type, Id) {
            if (type == 1) {
                for (var i = 0; i < this.Category.length; i++) {
                    if (this.Category[i].Id == Id) {
                        this.Form.ProCategory = "";
                    }
                }
            };
            if (type == 2) {
                for (var i = 0; i < this.ProTypeName.length; i++) {
                    if (this.ProTypeName[i].Id == Id) {
                        this.Form.ProTypeId = "";
                    }
                }
            };
            if (type == 3) {
                for (var i = 0; i < this.Brand.length; i++) {
                    if (this.Brand[i].Id == Id) {
                        this.Form.ProBrand = "";
                    }
                }
            };
            if (type == 4) {
                for (var i = 0; i < this.ProSpecName.length; i++) {
                    if (this.ProSpecName[i].Id == Id) {
                        this.Form.ProSpec = "";
                    }
                }
            };
            if (type == 5) {
                for (var i = 0; i < this.ProModelNumName.length; i++) {
                    if (this.ProModelNumName[i].Id == Id) {
                        this.Form.ProModelNum = "";
                    }
                }
            };
            if (type == 6) {
                for (var i = 0; i < this.naturalUnits.length; i++) {
                    if (this.naturalUnits[i].Id == Id) {
                        this.Form.ProNaturalUnit = "";
                        this.activenaturalUnits = "";
                    }
                }
            };
            if (type == 7) {
                for (var i = 0; i < this.saleUnits.length; i++) {
                    if (this.saleUnits[i].Id == Id) {
                        this.Form.ProSaleUnit = "";
                        this.activesaleUnits = "";
                    }
                }
            };
        },
        getClass() {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1]
            };
            GetProductClass(Params).then(res => {
                util.doResult(this, res, () => {
                    this.Class = res.data.Data;
                });
            });
            GetProductAttribute(Params).then(res => {
                util.doResult(this, res, () => {
                    this.Attribute = res.data.Data;
                });

            });
        },
        getSelectList(type, isAdd) {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                ParmType: type
            };
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 1) {
                        this.Category = res.data.Data;
                        this.table.data = this.Category;
                    };
                    if (type == 2) {
                        this.ProTypeName = res.data.Data;
                        this.table.data = this.ProTypeName;
                    };
                    if (type == 3) {
                        this.Brand = res.data.Data;
                        this.table.data = this.Brand;
                    };
                    if (type == 4) {
                        this.ProSpecName = res.data.Data;
                        this.table.data = this.ProSpecName;
                    };
                    if (type == 5) {
                        this.ProModelNumName = res.data.Data;
                        this.table.data = this.ProModelNumName;
                    };
                    if (type == 6) {
                        this.naturalUnits = res.data.Data;
                        this.table.data = this.naturalUnits;

                    };
                    if (type == 7) {
                        this.saleUnits = res.data.Data;
                        this.table.data = this.saleUnits;
                    };
                    if (isAdd == 1) {
                        if (type == 1) {
                            this.Form.ProCategory = this.Category[this.Category.length - 1].Id;
                        };
                        if (type == 2) {
                            this.Form.ProTypeId = this.ProTypeName[this.ProTypeName.length - 1].Id;
                        };
                        if (type == 3) {
                            this.Form.ProBrand = this.Brand[this.Brand.length - 1].Id;
                        };
                        if (type == 4) {
                            this.Form.ProSpec = this.ProSpecName[this.ProSpecName.length - 1].Id;
                        };
                        if (type == 5) {
                            this.Form.ProModelNum = this.ProModelNumName[this.ProModelNumName.length - 1].Id;
                        };
                        if (type == 6) {
                            this.activenaturalUnits = this.naturalUnits[this.naturalUnits.length - 1].Id;
                            for (var i = 0; i < this.naturalUnits.length; i++) {
                                if (this.naturalUnits[i].Id == this.activenaturalUnits) {
                                    this.Form.ProNaturalUnit = this.naturalUnits[i].ParmName
                                }
                            }
                        };
                        if (type == 7) {
                            this.activesaleUnits = this.saleUnits[this.saleUnits.length - 1].Id;
                            for (var i = 0; i < this.saleUnits.length; i++) {
                                if (this.saleUnits[i].Id == this.activesaleUnits) {
                                    this.Form.ProSaleUnit = this.saleUnits[i].ParmName
                                }
                            }
                        };
                    }
                });

            })
        },
        dialogClosed() {
            this.dialogContent = "";
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/productInformation/addProduct.js